import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Filters } from "./Filters";
import { Filter, QueryFilter } from "./Filters.types";
import { parseQueryStringFilters } from "./utility";
interface FiltersWithQueryProps {
  filters: any;
  onApply?: (search: string) => void;
}

export const FiltersWithQuery: React.FC<FiltersWithQueryProps> = ({ filters, onApply }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const normalizeFilterValue = (item: QueryFilter): QueryFilter => {
    if (!item.type.endsWith("Array") || typeof item.value !== "string") {
      return item;
    }

    try {
      return {
        ...item,
        value: JSON.parse(item.value),
      };
    } catch {
      return item;
    }
  };

  const onFilterChange = (queryFilters: QueryFilter[]) => {
    queryParams.delete("filters");
    queryParams.delete("skip");
    queryFilters.forEach((item) => {
      queryParams.append("filters", JSON.stringify(normalizeFilterValue(item)));
    });

    const newSearch = queryParams.toString();
    const currentSearch = new URLSearchParams(location.search).toString();

    if (newSearch === currentSearch) {
      // URL se ne menja — useEffect u hooku se neće trigerovati, pozovi direktno
      onApply?.("?" + newSearch);
    } else {
      navigate({ search: newSearch }, { replace: true });
    }
  };
  const setDefaultValues = (name: keyof typeof filters, valueF?: QueryFilter) => {
    let value = valueF?.value;
    if (valueF?.type === "date" || (valueF?.type === "dateArray" && value)) {
      if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
        return [new Date(value[0]), new Date(value[1])];
      }
      if (value) {
        if (valueF?.operator === "lte") return [undefined, new Date(value)];
        if (valueF?.operator === "gte") return [new Date(value), undefined];
      }
    }
    if ((valueF?.operator === "ne" || valueF?.operator === "eq") && value === null) {
      return valueF?.operator === "ne" ? "yes" : "no";
    }
    if ((valueF?.type === "boolean" || valueF?.type === "booleanArray") && value) {
      return value[0] === JSON.stringify(true) ? 1 : 0;
    }
    return typeof value === "number" ? value : value || undefined;
  };

  const getFilters = () => {
    const filtersFromQuery: any[] = parseQueryStringFilters(queryParams);
    let filtersWithValues: Filter[] = Object.keys(filters).map((item) => {
      const matchingFilters = filtersFromQuery.filter((it) => it.name === item);
      
      // For qdsSignatureData, we need to handle multiple filters with the same name
      if (item === "signaturesData" && matchingFilters.length > 0) {
        return {
          ...filters[item as keyof typeof filters],
          defaultValues: matchingFilters,
        };
      }

      // For documentMetaData, filters use the MetaDataItem key as name — match by type
      if (item === "documentData") {
        const docDataFilters = filtersFromQuery.filter((it) => it.type === "documentMetaData");
        if (docDataFilters.length > 0) {
          return {
            ...filters[item as keyof typeof filters],
            defaultValues: docDataFilters,
          };
        }
      }
      
      return {
        ...filters[item as keyof typeof filters],
        defaultValues: setDefaultValues(
          item as keyof typeof filters,
          matchingFilters.length > 0 ? matchingFilters[0] : undefined
        ),
      };
    });

    return filtersWithValues;
  };
  return <Filters filters={getFilters()} onFilterChange={onFilterChange} />;
};
